import { create } from "zustand";
import { send_request, send_request_optional_auth } from "../../utils/Request";

const usePublicChatStore = create((set) => ({
  createPublicChatShareLink: async (agentId, options = {}) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/public-chat/share-links`,
        options,
        {},
        "POST"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to create public chat share link" });
      return null;
    }
  },

  getPublicChatShareLink: async (agentId, shareId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/public-chat/share-links/${shareId}`,
        "",
        {},
        "GET"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to load public chat share link" });
      return null;
    }
  },

  getLatestPublicChatShareLink: async (agentId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/public-chat/share-links`,
        "",
        {},
        "GET"
      );
      return response?.data || null;
    } catch (e) {
      set({
        error: e.message || "Failed to load latest public chat share link",
      });
      return null;
    }
  },

  revokePublicChatShareLink: async (agentId, shareId, payload = {}) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/public-chat/share-links/${shareId}/revoke`,
        payload,
        {},
        "POST"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to revoke public chat share link" });
      return null;
    }
  },

  bootstrapPublicChat: async (token) => {
    try {
      const response = await send_request_optional_auth(
        `project-service/agent-chat/${token}/bootstrap`,
        "",
        {},
        "GET"
      );
      return response?.data || null;
    } catch (e) {
      throw e;
    }
  },

  requestPublicChatMagicLink: async (token, email) => {
    return send_request_optional_auth(
      `project-service/agent-chat/${token}/magic-link/request`,
      { email },
      {},
      "POST"
    );
  },

  verifyPublicChatMagicLink: async (verificationToken) => {
    return send_request_optional_auth(
      "project-service/agent-chat/magic-link/verify",
      { verificationToken },
      {},
      "POST"
    );
  },

  listPublicChatSessions: async (token, payload = {}) => {
    return send_request_optional_auth(
      `project-service/agent-chat/${token}/sessions`,
      payload,
      {},
      "POST"
    );
  },

  startPublicChat: async (token, payload) => {
    return send_request_optional_auth(
      `project-service/agent-chat/${token}/start`,
      payload,
      {},
      "POST"
    );
  },

  getPublicChatSession: async (publicSessionToken, payload = {}) => {
    return send_request_optional_auth(
      `project-service/agent-chat/session/${publicSessionToken}`,
      payload,
      {},
      "POST"
    );
  },

  sendPublicChatMessage: async (publicSessionToken, payload) => {
    return send_request_optional_auth(
      `project-service/agent-chat/session/${publicSessionToken}/message`,
      payload,
      {},
      "POST"
    );
  },
}));

export default usePublicChatStore;
